module.exports = __webpack_public_path__ + "static/media/DeskImg.b7397c88.png";